<div id="iframe" *ngIf="data">
	<iframe scrolling="auto" [src]="data" frameborder="0" style="border: 0px none; height: 100%; width: 100%" allowtransparency></iframe>
</div>
